import React from "react";
//import { makeStyles } from "tss-react/mui";
//import { Theme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";

import { useNavigate } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { Typography } from "@mui/material";
import GravatarAvatar from "./GravatarAvatar";

/*
const useStyles = makeStyles()((theme: Theme) => ({
}));
*/

export default function Title(props: any) {
  //const { classes } = useStyles();
  const navigate = useNavigate();
  const { signOut, user } = useAuthenticator((context) => [context.user]);
  const { route } = useAuthenticator((context) => [context.route]);

  const handleSignOutClick = async () => {
    signOut();
    navigate("/login");
  };

  const handleBackClick = async () => {
    navigate(-1);
  };

  return (
    <AppBar position="fixed">
      <Toolbar>
        {props.showBack ? (
          <span>
            <Button
              variant="contained"
              color="primary"
              onClick={handleBackClick}
            >
              Back
            </Button>
            &nbsp;&nbsp;
          </span>
        ) : null}

        <img src="/favicon-32x32.png" alt="llm-logo" />&nbsp;&nbsp;

        <Typography variant="h5" component="div" sx={{ flexGrow: 1 }}>
          LLM as a Service - add LLM features to your app
        </Typography>

        {route === "authenticated" ? (
          <GravatarAvatar
            email={user.attributes?.email || ""}
            size={40}
            onLogout={handleSignOutClick}
          />
        ) : null}
      </Toolbar>
    </AppBar>
  );
}
